/** "Useful?" with a thumb each way, in the title row of a page's first results panel beside Export. A thumb up
 *  is sent at once; a thumb down opens one line under the row, like Export's form. Nothing identifies the
 *  visitor; the page and the words go to Admin > Feedback. Answered, it becomes a quiet "Thanks" in place, and
 *  asks again when the page shows a different model (`key` it on the model). */
import { useState } from 'react'
import { api } from '../api'

const Up = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.3a2 2 0 0 0 2-1.7l1.4-9a2 2 0 0 0-2-2.3H14z" /><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
  </svg>
)
const Down = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.7a2 2 0 0 0-2 1.7l-1.4 9a2 2 0 0 0 2 2.3H10z" /><path d="M17 2h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3" />
  </svg>
)

export function Useful({ page }: { page: 'calculator' | 'compare' | 'fit' | 'ask' | 'trending' | 'data' | 'simulation' | 'optimise' }) {
  const [note, setNote] = useState('')
  const [trap, setTrap] = useState('')
  const [state, setState] = useState<'idle' | 'asking' | 'busy' | 'done'>('idle')
  const send = async (up: boolean, text = '') => {
    setState('busy')
    try { await api.feedback({ page, up, note: text, website: trap }); setState('done') }
    catch { setState('done') }                              // a brake or a hiccup: the thanks is the same
  }
  if (state === 'done') return <span className="useful done" role="status">Thanks — noted.</span>
  return (
    <span className="useful" data-tour="useful">
      <span className="lbl">Useful?</span>
      <button type="button" className="pill" aria-label="Yes, useful" title="Yes, useful" disabled={state === 'busy'}
        onClick={() => void send(true)}><Up /></button>
      <button type="button" className="pill" aria-label="No, something was missing" title="No, something was missing"
        aria-pressed={state === 'asking'} disabled={state === 'busy'}
        onClick={() => setState(state === 'asking' ? 'idle' : 'asking')}><Down /></button>
      {state === 'asking' || state === 'busy' ? (
        <form className="usefulpop" role="dialog" aria-label="What was missing" noValidate
          onSubmit={(e) => { e.preventDefault(); void send(false, note) }}>
          <b>What was missing?</b>
          <input type="text" value={note} maxLength={1000} placeholder="One line is enough" autoFocus
            onChange={(e) => setNote(e.target.value)} disabled={state === 'busy'} />
          <input className="trap" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" value={trap} onChange={(e) => setTrap(e.target.value)} />
          <span className="row">
            <button type="submit" className="primary" disabled={state === 'busy'}>Send</button>
            <button type="button" className="linklike" disabled={state === 'busy'} onClick={() => void send(false)}>just the thumb</button>
            <span className="spacer" />
            <span className="muted small">anonymous</span>
          </span>
        </form>
      ) : null}
    </span>
  )
}
